import { render, staticRenderFns } from "./t-app-notification.vue?vue&type=template&id=28cd0ee5&scoped=true&"
import script from "./t-app-notification.vue?vue&type=script&lang=js&"
export * from "./t-app-notification.vue?vue&type=script&lang=js&"
import style0 from "./t-app-notification.vue?vue&type=style&index=0&id=28cd0ee5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cd0ee5",
  null
  
)

export default component.exports